/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = css({
	width: '4rem',
	height: '3rem',
	borderRadius: token('radius.small'),
});

type ThemeThumbnailProps = {
	src: string;
};

export default function ThemeThumbnail({ src }: ThemeThumbnailProps) {
	return <img src={src} alt="" css={styles} />;
}
